import * as React from "react";
import {cs} from "../../../../../../../../../../react/chain-services";
import "./address-form.scss";
import {cx} from "emotion";
import {Select} from "../../../../../../../../common/design2/select/select";
import {Form2} from "../../../../../../../../../../react/cs-form-2/form2";
import {UseState} from "../../../../../../../../../../react/use-state";
import {required} from "../../../../../../../../../../react/cs-form-2/validators/required";
import {chain} from "../../../../../../../../../../utils/fs";
import {bindInput} from "../../../../../../../../../../react/bind-input";
import {isDevQuan} from "../../../../../../../../../debug/is-dev-quan";
import {cc} from "../../../../../../../../../../react/callback-chain";

export const AddressForm = ({line1, query, next}) => cs(
    ["apiError", (_, next) => UseState({next})],
    ["data", ({apiError}, next) => cc([
        (_, next) => UseState({
            initValue: {...query.value}, 
            next,
        }),
        ({value, onChange}) => next({
            value,
            onChange: (v) => {
                onChange(v);
                apiError.onChange(null);
            },
        })
    ])],
    ["showErrors", (_, next) => UseState({next})],
    ["form", ({data}, next) => Form2({
        data,
        showErrors: true,
        fields: [
            {
                path: [line1.path],
                validators: line1.validators,
            },
            ...["address", "city", "state", "zip"].map((path) => ({
                path: [path],
                validators: [required],
            })),
            {
                path: ["address2"],
            },
        ],
        next,
    })],
    ({form, data, showErrors, apiError}) => next({
        render: ({showErrors: showErrors1, onSearch}) => {
            const getField = (path) => chain(
                form.field(path),
                (field) => ({
                    ...field,
                    error: !(showErrors1 || showErrors.value) ? null : field.error,
                }),
            );
            const usStates = require("../../../../../../../../common/us-states.json");
            return (
                <div className="address-form-8l9">

                    <div className="form">
                        <div className="lines">
                            {[
                                {
                                    label: line1.label,
                                    control: line1.control(getField(line1.path)),
                                },
                                {
                                    label: "Address Line 1",
                                    control: chain(
                                        getField("address"),
                                        (field) => <input {...{
                                            className: cx({hasError: field.error}),
                                            ...bindInput(field.state),
                                            "xd-qa-type": "text_field",
                                            "xd-qa-name": "Demographics Search Address Line 1",
                                        }}/>,
                                    ),
                                    className: "address-line",
                                },
                                {
                                    label: "Address Line 2",
                                    control: chain(
                                        getField("address2"),
                                        (field) => <input {...{
                                            className: cx({hasError: field.error}),
                                            ...bindInput(field.state),
                                            "xd-qa-type": "text_field",
                                            "xd-qa-name": "Demographics Search Address Line 2",
                                        }}/>,
                                    ),
                                    className: "address-line",
                                },
                                {
                                    label: "City, State, Zip",
                                    control: <>
                                        <div className="city">
                                            {chain(
                                                getField("city"),
                                                (field) => <input {...{
                                                    placeholder: "City",
                                                    className: cx({hasError: field.error}),
                                                    ...bindInput(field.state),
                                                    "xd-qa-type": "text_field",
                                                    "xd-qa-name": "Demographics Search City",
                                                }}/>,
                                            )}
                                        </div>
                                        <div className="state">

                                            {chain(
                                                getField("state"),
                                                (field) => Select({
                                                    list: usStates,
                                                    itemToLabel: (s) => s.name,
                                                    isSelected: (e) => field.state.value === e.abbreviation,
                                                    onChange: (e) => field.state.onChange(e.abbreviation),
                                                    placeholder: "State",
                                                    style: {
                                                        color: field.error ? "danger" : null,
                                                    },
                                                    autofill: {
                                                        getItem: (str) => (
                                                            usStates.find((s) => s.abbreviation === str) ??
                                                            usStates.find((s) => s.name.toLowerCase() === str.toLowerCase())
                                                        ),
                                                        name: "state",
                                                    },
                                                    xdQaName: "Demographics Search State",
                                                }),
                                            )}
                                        </div>
                                        <div className="zip">
                                            {chain(
                                                getField("zip"),
                                                (field) => <input {...{
                                                    placeholder: "Zip",
                                                    className: cx({hasError: field.error}),
                                                    ...bindInput(field.state),
                                                    "xd-qa-type": "text_field",
                                                    "xd-qa-name": "Demographics Search Zip",
                                                }}/>,
                                            )}
                                        </div>
                                    </>,
                                    className: "city-state-zip",
                                },
                            ]
                                .map(({label, control, className}, i) => (
                                    <div className="line" key={i}>
                                        <div className="label" xd-qa-type="label" xd-qa-name={"Demographics Search "+label}>
                                            {label}
                                        </div>
                                        <div className={cx("control", className)}>
                                            {control}
                                        </div>
                                    </div>
                                ))
                            }
                        </div>

                        {apiError.value && (
                            <div className="error" xd-qa-type="label" xd-qa-name="Demographics Search Error">
                                {apiError.value.msg ?? "Unknown search error"}
                            </div>
                        )}

                        <div className="footer">
                            {cs(
                                ["searching", (_, next) => UseState({next})],
                                ({searching}) => (
                                    <button {...{
                                        className: cx("search", {
                                            disabled: form.invalid,
                                        }),
                                        disabled: searching.value,
                                        onClick: () => form.submit({
                                            onRejected: () => {
                                                showErrors.onChange(true);
                                            },
                                            onSubmit: async () => {
                                                searching.onChange(true);
                                                try {
                                                    await onSearch(data.value);
                                                } catch (e) {
                                                    apiError.onChange({msg: e});
                                                } finally {
                                                    searching.onChange(false);
                                                }
                                            },
                                        }),
                                        "xd-qa-type": "button",
                                        "xd-qa-name": "Demographics Search Search",
                                    }}>
                                        {searching.value ? (
                                            "Searching..."
                                        ) : (
                                            "Search"
                                        )}
                                    </button>
                                ),
                            )}
                        </div>
                    </div>
                </div>
            );
        },
    })
);
